import React, {ReactNode} from 'react';
import {makeStyles} from "@mui/styles";
import {Theme} from "@mui/material";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        maxWidth: theme.typography.pxToRem(792),
        width: "100%",
        margin: "0 auto"
    }
}));

interface Props {
    readonly children: ReactNode
}

export function Container({children}:Props) {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            {children}
        </div>
    );
}

